import Swiper from 'swiper'
import composedPath from './helpers/composedPath'

export default class {
  constructor(entries) {
    this.entries = entries

    this.createElements()
    this.addEntries()
    this.createSwiper()

    // Add event listeners for page load and resize to adjust slider controls position.
    window.addEventListener('load', this.setSliderControls.bind(this))
    window.addEventListener('resize', this.setSliderControls.bind(this))
  }

  openModal(index) {
    this.swiper.update()

    if (index) {
      this.swiper.slideTo(index, 1)
    }

    this.onChange()

    document.body.classList.add('person-modal-open')
  }

  closeModal() {
    document.body.classList.remove('person-modal-open')
  }

  createSwiper() {
    this.close.addEventListener('click', this.closeModal.bind(this))
    this.backdrop.addEventListener('click', this.closeModal.bind(this))
    document.addEventListener('keydown', (e) => {
      if (e.key == 'Escape') {
        this.closeModal()
      }
    })

    this.swiper = new Swiper(this.swiperContainer, {
      slidesPerView: 1,
      direction: 'horizontal',
      loop: false,
      keyboard: {
        enabled: true,
        onlyInViewport: false,
      },
    })

    this.next.addEventListener('click', (e) => {
      this.swiper.slideNext()
    })

    this.prev.addEventListener('click', (e) => {
      this.swiper.slidePrev()
    })

    this.swiper.on('slideChange', () => {
      this.onChange()
      this.setSliderControls()
    })
  }

  onChange() {
    if (this.swiper.activeIndex === 0) {
      this.prev.classList.add('-hidden')
    } else {
      this.prev.classList.remove('-hidden')
    }

    if (this.swiper.activeIndex === this.swiper.slides.length - 1) {
      this.next.classList.add('-hidden')
    } else {
      this.next.classList.remove('-hidden')
    }
  }

  createElements() {
    this.wrapper = document.createElement('div')
    this.wrapper.classList.add('person-modal')

    this.backdrop = document.createElement('div')
    this.backdrop.classList.add('backdrop')

    this.swiperContainer = document.createElement('div')
    this.swiperContainer.classList.add('swiper-container')

    this.swiperWrapper = document.createElement('div')
    this.swiperWrapper.classList.add('swiper-wrapper')

    this.next = this.getIcon('next', 40)
    this.prev = this.getIcon('prev', 40)
    this.close = this.getIcon('close', 30)

    this.wrapperButtons = document.createElement('div')
    this.wrapperButtons.classList.add('swiper-buttons')

    this.swiperContainer.appendChild(this.swiperWrapper)
    this.wrapper.appendChild(this.swiperContainer)
    this.wrapper.appendChild(this.backdrop)
    this.wrapperButtons.appendChild(this.next)
    this.wrapperButtons.appendChild(this.prev)
    this.wrapperButtons.appendChild(this.close)
    this.swiperContainer.appendChild(this.wrapperButtons)

    document.body.appendChild(this.wrapper)
  }

  addEntries() {
    let index = 0
    for (const person of this.entries) {
      const inner = person.querySelector('[data-inner]')
      person.setAttribute('data-index', index)

      if (inner) {
        const slide = document.createElement('div')
        slide.classList.add('swiper-slide')
        slide.appendChild(inner)
        this.swiperWrapper.appendChild(slide)

        person.addEventListener('click', (e) => {
          // Allowing using contextual links in person cards.
          if (e.target.matches('.contextual button')) return
          if (e.target.matches('.contextual-links a')) return

          const path = composedPath(e)
          for (let i = 0; i < path.length; i++) {
            if (path[i].hasAttribute('data-index')) {
              this.openModal(path[i].getAttribute('data-index'))
              break
            }
          }
        })

        index++
      }
    }
  }

  getIcon(icon, size) {
    const button = document.createElement('button')
    button.classList.add('swiper-button')
    button.classList.add(`-${icon}`)
    button.innerHTML = `<svg width="${size}" height="${size}" class="icon icon--${icon} -${icon}">
        <use xmlns:xlink="http://www.w3.org/1999/xlink" xlink:href="#${icon}"></use>
        </svg>`

    return button
  }

  setSliderControls() {
    const activeSlide = this.swiper.slides[this.swiper.activeIndex]
    if (activeSlide) {
      const teaserElement = activeSlide.querySelector('.teaser')
      if (teaserElement) {
        const teaserWidth = teaserElement.clientWidth
        const teaserHeight = teaserElement.clientHeight

        this.wrapperButtons.style.width = `${teaserWidth}px`
        this.wrapperButtons.style.height = `${teaserHeight}px`
        this.wrapperButtons.style.marginLeft = `-${teaserWidth / 2 + 8}px`
        this.wrapperButtons.style.marginTop = `-${teaserHeight / 2}px`
      }
    }
  }
}
